import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import {
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { NgbTooltip, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {
  CountryISO,
  NgxIntlTelInputComponent,
  NgxIntlTelInputModule,
  PhoneNumberFormat,
  SearchCountryField,
} from 'ngx-intl-tel-input';
import { Subject, distinctUntilChanged, takeUntil } from 'rxjs';
import { selectAlternateLoader } from '../../ngrx/data.reducer';
import { ResizeService } from '../../services/resize.service';
import { DirectivesModule } from '../../tsExtras/directives.module';
declare var $: any;
@Component({
  selector: 'app-input',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    NgbTooltipModule,
    FormsModule,
    DirectivesModule,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
})
export class InputComponent {
  @Input() type: string = 'text';
  @Input() rows: string = '2';
  @Input() cstmStyle: string = null;
  @Input() toolTip: string = null;
  @Input() readOnly: boolean = false;
  @Input() icon: IconDefinition;
  @Input() form: any;
  @Input() control: string;
  @Input() placeholder: string = '';
  @Input() label: string;
  @Input() classes: any;
  @Input() selectedCountryISO: any;
  @Input() password: boolean = false;
  @Input() inputType: string = 'text';
  @Input() NumbersOnly: boolean = false;
  @Input() limit: number;
  @Input() meter: boolean = false;
  @Input() prefixs: string = null;
  @Input() array = null;
  faInfoCircle = faInfoCircle;
  SearchCountryField = SearchCountryField;
  PhoneNumberFormat = PhoneNumberFormat;
  CountryISO = CountryISO;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  faExclamationCircle = faExclamationCircle;
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  isFocused: boolean = false;
  error: boolean = false;
  value: string = null;
  errorName: string;
  loader$ = this.store.select(selectAlternateLoader);
  loader: boolean = false;
  content: string = 'Too Short';
  meterStatusColor = '#ff0000';
  meterBarColor = '#ff0000';
  meterBarWidth = '10%';
  private destroy$ = new Subject<void>();
  @ViewChild('tooltip') tooltip: NgbTooltip;
  @Output() mobileEmitter: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('phoneInput') phoneInput: NgxIntlTelInputComponent;
  constructor(
    private store: Store,
    public resize: ResizeService,
  ) {
    this.loader$
      .pipe(
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe((loader) => {
        this.loader = loader;
      });
  }
  ngOnInit(): void {
    setTimeout(() => {
      if (this.form?.controls?.[this.control]?.value?.length > 0) {
        this.isFocused = true;
        this.value = this.form?.controls?.[this.control]?.value;
      }
      if (this.inputType == 'phone') {
        this.isFocused = true;
      }
    }, 500);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.reset();
  }
  togglePlaceholder(state: boolean): void {
    this.error = this.form.controls[this.control].status == 'INVALID';
    for (const key in this.form.controls[this.control].errors) {
      this.errorName = key;
    }
    if (state) {
      this.isFocused = state;
      if (window.innerWidth > 1024) {
        if (this.error) {
          this.tooltip && this.tooltip.open();
        }
      }
    } else {
      if (window.innerWidth > 1024) {
        this.tooltip && this.tooltip.close();
      }
      if (!this.value) {
        this.isFocused = state;
      }
    }
  }
  reset(): void {
    this.isFocused = false;
    this.error = false;
    this.value = null;
    this.errorName = null;
    this.loader = false;
    this.content = 'Too Short';
    this.meterStatusColor = '#ff0000';
    this.meterBarColor = '#ff0000';
    this.meterBarWidth = '10%';
  }
  write(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.id != 'country-search-box') {
      this.form.controls[this.control].setValue(input.value);
      this.value = input.value;
      this.error = this.form.controls[this.control].status == 'INVALID';
      if (input.value?.length > 0) {
        this.togglePlaceholder(true);
      }
      if (window.innerWidth > 1024) {
        if (this.error) {
          this.tooltip && this.tooltip.open();
        } else {
          this.tooltip && this.tooltip.close();
        }
      }
      for (const key in this.form.controls[this.control].errors) {
        this.errorName = key;
      }
    }
  }
  returnFirstLetterCapital(input: string): string {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }
  onPrefixChange(event: any) {
    const inputElement = event.target as HTMLInputElement;
    let input = inputElement.value;
    if (!input.startsWith(this.prefixs)) {
      inputElement.value = this.prefixs;
    } else {
      const additionalContent = input.slice(this.prefixs.length);
      inputElement.value = this.prefixs + additionalContent;
    }
  }
  checkStrength(event: any): void {
    const password = event.target.value;
    let strength = 0;
    if (password.length > 0 && password.length < 8) {
      this.meterBarColor = '#ff0000';
      this.meterBarWidth = '10%';
      this.meterStatusColor = '#ff0000';
      this.content = 'Too Short';
      return;
    }
    if (password.length >= 8) strength += 1;
    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) strength += 1;
    if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/))
      strength += 1;
    if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1;
    switch (strength) {
      case 0:
        this.meterBarWidth = '0';
        break;
      case 1:
        this.meterBarColor = '#6B778D';
        this.meterBarWidth = '25%';
        this.meterStatusColor = '#6B778D';
        this.content = 'Weak';
        break;
      case 2:
        this.meterBarColor = '#00BCD4';
        this.meterBarWidth = '75%';
        this.meterStatusColor = '#00BCD4';
        this.content = 'Good';
        break;
      default:
        this.meterBarColor = '#4CAF50';
        this.meterBarWidth = '100%';
        this.meterStatusColor = '#4CAF50';
        this.content = 'Strong';
        break;
    }
  }
  onCountryChange(event: any) {
    this.mobileEmitter.emit(event);
  }
}
